export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const API_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
export const DEFAULT_DATE_LOCALE = 'en-gb';
export const DEFAULT_TIME_ZONE = 'Europe/London';
